export const FILTERS = {
  date: 'dateRange',
  region: 'dropDown',
  cat_or_uncat: 'dropDown'
};
